import { createSlice } from '@reduxjs/toolkit';

const getInitialTheme = () => {
    if (typeof window === "undefined") return "navy";

    try {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        return (
            (user?.id && localStorage.getItem(`theme_user_${user.id}`))
            || user?.theme
            || localStorage.getItem("theme")
            || "navy"
        );
    } catch (error) {
        return localStorage.getItem("theme") || "navy";
    }
};

const initialState = {
    themeId: getInitialTheme(),
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.themeId = action.payload;
        },
    },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
